import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Page Tracker Component
 * Tracks page views in Google Analytics whenever the route changes
 */
export const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip tracking for automated/test traffic
    const ua = navigator.userAgent.toLowerCase();
    const isTest = ua.includes('headless') || ua.includes('playwright') || navigator.webdriver ||
      window.location.hostname === 'localhost' || window.location.hostname.includes('--');
    if (isTest) return;

    // Track page view in Google Analytics
    if (typeof window !== 'undefined' && (window as any).gtag) {
      const gtag = (window as any).gtag;

      gtag('config', 'G-YEL11ZFMBW', {
        page_path: location.pathname,
        page_title: document.title,
      });

      // Also track as a pageview event
      gtag('event', 'page_view', {
        page_path: location.pathname,
        page_title: document.title,
      });
    }
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default PageTracker;
